import React from 'react';
import ReactTable from 'react-table';
import styled from 'styled-components';
import PaginationComponent from './PaginationComponent';
import LoaderImage from './LoaderImage';
const PAGE_SIZES = [50, 100, 500];
export default class DataTable extends React.Component {
    shouldComponentUpdate(nextProps, nextState, newContent) {
        //
        // PLEASE NOTE: This is an optimization that would update this component
        // only when the initial data is loaded. The component assumes that it will be re-created
        // when new data is loaded from the server
        //
        return typeof (this.props.dataHash) === "undefined" || this.props.dataHash === null || (this.props.dataHash !== nextProps.dataHash);
    }
    render() {
        const { className, columns, data, totalRowCount, defaultSorted, onSortedChange, pages, onFetchData, minRows = 0, noDataText = "No Results", loading = false, tableComponent, theadComponent, thComponent, tdComponent, trComponent, tfootComponent, getTrProps, useStickyHeaders = false, } = this.props;
        const TableWrapperComponent = useStickyHeaders ? StickyTableWrapper : DefaultTableWrapper;
        return React.createElement(TableWrapperComponent, { className: className, TableComponent: tableComponent || DefaultTableComponent, TheadComponent: theadComponent || (useStickyHeaders ? StickyTheadComponent : DefaultTheadComponent), TbodyComponent: TbodyComponent, TrGroupComponent: TrGroupComponent, TrComponent: trComponent || DefaultTrComponent, ThComponent: thComponent || DefaultThComponent, TdComponent: tdComponent || DefaultTdComponent, TfootComponent: tfootComponent || DefaultTfootComponent, PaginationComponent: PaginationComponent, LoadingComponent: LoadingComponent, NoDataComponent: NoDataComponent, collapseOnDataChange: false, getTrProps: getTrProps, columns: columns, data: data, defaultPageSize: 50, pageSizeOptions: PAGE_SIZES, pages: pages, showPagination: totalRowCount > 50, getPaginationProps: () => ({ totalRowCount: totalRowCount || 'many' }), pageText: 'Showing', rowsText: '', ofText: 'of', minRows: minRows, noDataText: loading ? '' : noDataText, defaultSorted: defaultSorted, onSortedChange: onSortedChange, onFetchData: onFetchData, manual: onFetchData != null, loading: loading, onPageChange: () => {
                window.scrollTo(0, 0);
            } });
    }
}
const DefaultTableWrapper = styled(ReactTable) `
  overflow: auto;
`;
const StickyTableWrapper = styled(DefaultTableWrapper) `
  height: 90vh; // required for position: sticky to work with overflow auto

  @media (max-width: 768px) { // tablets and smaller
      height: 800px;
  }
`;
const DefaultTableComponent = styled.table `
  width: 100%;

  margin: 0;
  padding: 0;
  border-collapse: collapse;

  font-family: ${props => props.theme.fonts.regular};
  text-align: left;
  font-size: 14px;
  font-weight: 300;

  border-radius: 4px;
`;
const DefaultTheadComponent = styled.thead `
  font-family: ${props => props.theme.fonts.demi};
  color: ${props => props.theme.colors.tertiaryText};
  background-color: ${props => props.theme.colors.silverLighter};
`;
const StickyTheadComponent = styled(DefaultTheadComponent) `
  position: sticky;
  top: 0;
  background-clip: padding-box; // required for safari

  tr:hover {
    background-clip: padding-box !important; // required for safari
    background: rgba(241, 248, 253); // equivalent to rgba(216,238,252,0.40) but with opacity 1
  }
`;
const TbodyComponent = styled.tbody `
  tr {
    border-bottom: 1px solid rgba(150,159,170,0.20);
  }
`;
const TrGroupComponent = ({ children }) => (React.createElement(React.Fragment, null, children));
const DefaultTrComponent = styled.tr `
  :hover {
    background: rgba(216,238,252,0.40);
  }
`;
const DefaultThComponent = ({ toggleSort, className, children, ...rest }) => (React.createElement(ThComponentContent, { onClick: e => (toggleSort && toggleSort(e)), role: "columnheader", tabIndex: -1, libraryClasses: className, ...rest }, children));
const ThComponentContent = styled("th") `
  padding: 16px 6px;
  max-width: unset !important;

  outline: none;

  cursor: pointer;
  
  border-right: 1px solid rgba(150,159,170,0.20);
  :last-child {
    border-right: none;
  }

  box-shadow: none;
  box-shadow: ${props => props.libraryClasses.includes('sort-asc') && `inset 0 2px 0 0 ${props.theme.colors.blueLight}`};
  box-shadow: ${props => props.libraryClasses.includes('sort-desc') && `inset 0 -2px 0 0 ${props.theme.colors.blueLight}`};
`;
const DefaultTdComponent = styled.td `
  margin: 0;
  padding: 0;

  padding: 16px 6px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  border-right: 1px solid rgba(150,159,170,0.20);
  :last-child {
    border-right: none;
  }
`;
const DefaultTfootComponent = styled.tfoot `
  font-family: ${props => props.theme.fonts.demi};
  background-color: ${props => props.theme.colors.silverLighter};
`;
const LoadingComponentInner = ({ loading, ...rest }) => (React.createElement("div", { ...rest },
    React.createElement(LoaderImage, { width: "25px", height: "25px", styleContainer: false })));
const LoadingComponent = styled(LoadingComponentInner) `
  display: none;
  display: ${props => props.loading && 'block'};

  position: ${props => props.loading && 'absolute'};

  left: 50%;
  top: 50%;

  margin: 0 auto 30px auto;

  width: 25px;
  height: 25px;
`;
const NoDataComponent = styled.div `
  margin-top: 20px;

  text-align: center;

  font-family: ${props => props.theme.fonts.demi};
  font-size: 14px;
  color: ${props => props.theme.colors.tertiaryText};
`;
//# sourceMappingURL=DataTable.js.map